export const GEOSERVICE_NAME: { [key: string]: string } = {
	yandex: "Yandex",
	google: "Google",
	"2gis": "2Gis",
	bankiru: "Banki.ru",
	prodoctorov: "Prodoctorov",
	napopravku: "Напоправку",
	tripadvisor: "Tripadvisor",
	flamp: "Flamp",
	zoon: "Zoon",
};
